import Logo from '../../assets/logo-header.png';
import TitleBack from '../../assets/v2/title_back.png';
import IconValet from '../../assets/v2/service_icon_valet.png';
import IconTires from '../../assets/v2/service_icon_tires.png';
import IconCarwash from '../../assets/v2/service_icon_carwash.png';

import React, {forwardRef, useEffect, useState} from "react";
import ChooseServiceItem from "./ChooseServiceItem";
import {ServiceType} from "../../constants/ServiceType";
import useOrderStore from "./useOrderStore";
import {useSelector} from "react-redux";
import {getIsBranded} from "../branded/locationGroupSlice";
import {useTranslation} from "react-i18next";

const services = [
    {
        id: ServiceType.VALET,
        title: 'service.step_choose_service.service_valet.label',
        description: 'service.step_choose_service.service_valet.description',
        icon: IconValet,
    },
    {
        id: ServiceType.CARWASH,
        title: 'service.step_choose_service.service_carwash.label',
        description: 'service.step_choose_service.service_carwash.description',
        icon: IconCarwash,
    },
    {
        id: ServiceType.TIRES,
        title: 'service.step_choose_service.service_tires.label',
        description: 'service.step_choose_service.service_tires.description',
        icon: IconTires,
    }]

function ChooseService({
                           serviceTypeList
                       }, ref) {
    const {
        serviceId,
        setServiceId,
    } = useOrderStore();

    const [filteredServices, setFilteredServices] = useState([]);

    // Vitrine
    const isBranded = useSelector(getIsBranded);
    const {t} = useTranslation('common');

    useEffect(() => {
            if (t == null) {
                return;
            }
            // On filtre les services avec ce qu'on a
            const fServices = services.filter((item) => serviceTypeList.map((type) => type.id).includes(item.id));

            // On les traduit
            fServices.forEach((item) => {
                item.title = t(item.title)
                item.description = t(item.description)
            });

            setFilteredServices(fServices);
        },
        [serviceTypeList, t]);

    return (
        <div className="w-full flex justify-center flex-col gap-4 items-center font-DMSans p-2">

            {!isBranded ? <img src={Logo} className="h-[100px]"/> : null}

            <div className="w-full flex justify-center flex-wrap">
                <div
                    style={{'--image-url': `url(${TitleBack})`}}
                    className="bg-[image:var(--image-url)] w-[400px] bg-contain bg-no-repeat flex justify-center text-center flex-col p-0 gap-0">
                    <div className="m-[-2px]">{t('service.step_choose_service.title')}</div>
                    <div className="p-0 text-2xl"><b>{t('service.step_choose_service.title2')}</b></div>
                </div>
            </div>
            {
                filteredServices.map((item) => {
                    return <ChooseServiceItem key={item.id} item={item}
                                              itemSelectedHandler={(item) => setServiceId(item.id)}/>
                })
            }
        </div>
    );
}

export default forwardRef(ChooseService);